import { createAsyncThunk } from "@reduxjs/toolkit";

import { getUserProfile as getUserProfileApi } from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import {
  getUsersByEntity,
  addNewUserApi,
  changeUserStatus,
  updateUserRoleApi,
} from "../../helpers/dataBackend";
import { AppDispatch } from "slices";
import { fetchUsersFailure, fetchUsersSuccess, listUsers } from "./reducer";

export const fetchUsersEntity = () => async (dispatch: AppDispatch) => {
  dispatch(listUsers());
  try {
    const response = await getUsersByEntity();
    dispatch(fetchUsersSuccess(response));
  } catch (error: any) {
    dispatch(fetchUsersFailure(error));
  }
};

//Usuarios que pertenencen a la Entidad
export const getUsersEntity = createAsyncThunk(
  "usersEntity/getUsersEntity",
  async () => {
    try {
      const response = getUsersByEntity();
      return await response;
    } catch (error) {
      return error;
    }
  }
);

//Crear nuevos usuarios a la entidad
export const addNewUser = createAsyncThunk(
  "user/adduser",
  async (user: any) => {
    try {
      const response = addNewUserApi(user);
      const data = await response;
      toast.success("User Added Successfully", { autoClose: 2000 });
      return data;
    } catch (error) {
      toast.error("User Added Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const updateUserRole = createAsyncThunk(
  "user/updateuser",
  async (user: any) => {
    const userInfoUpdate = {
      name: user.name,
      last_name: user.last_name,
      roles: user.roles,
    };
    try {
      const response = await updateUserRoleApi(user.id, userInfoUpdate);
      if (response) {
        toast.success("User Updated Successfully", { autoClose: 2000 });
      }
      // return response;
    } catch (error) {
      toast.error("User Updated Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const deleteUsers = createAsyncThunk(
  "user/deleteUsers",
  async (id: any, { dispatch }) => {
    try {
      const response = await changeUserStatus(id);
      toast.success("User Deleted Successfully", { autoClose: 2000 });
      return response;
    } catch (error) {
      toast.error("User Deleted Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const getUserProfile = createAsyncThunk(
  "contacts/getUserProfile",
  async () => {
    try {
      const response = getUserProfileApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);
